





































































import { biBrow } from '@tencent/fit-bi-sdk';
import { computed, defineComponent, nextTick, onMounted, PropType, ref, watchEffect } from '@vue/composition-api';
import { useScroll } from '@vueuse/core';
import { parseCurrencyAria } from '@tencent/wphk-act-base-ui';

type TabType = {
  /** 分类关键词 */
  key: string;
  /** 分类名 */
  name: string;
  /** 分类图标 */
  icon?: string;
  /** 默认状态字体颜色 */
  tabColor?: string;
  /** 激活状态字体颜色 */
  tabActiveColor?: string;
};

export default defineComponent({
  name: 'Tab',
  props: {
    tabId: {
      type: String,
      required: true,
    },
    tabConfig: {
      type: Array as PropType<TabType[]>,
      required: true,
      default: () => [],
    },
    initActiveTab: String,
    /** 如果从外部传入activeTab，则该tab为受控组件 */
    curActiveTab: {
      required: false,
      type: String,
    },
    /** tab字体大小 */
    fontSize: {
      type: Number,
      default: 24,
    },
    /** tab默认字体颜色 */
    fontColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.5)',
    },
    /** tab行高 */
    lineHeight: {
      type: Number,
      default: 48,
    },
    /** tab底部边距 */
    marginBottom: {
      type: Number,
      default: 8,
    },
    /** tab 元素对齐方式 */
    justifyContent: {
      type: String,
      default: 'space-around',
    },
    borderWidth: {
      type: Number,
      default: 4,
    },
    borderColor: {
      type: String,
      default: '#fff',
    },
  },
  setup(prop, { emit }) {
    const tabContainer = ref<HTMLDivElement | null>(null);
    const { arrivedState } = useScroll(tabContainer);
    /**  */
    const isTabScrollEnd = computed(() => arrivedState.right);

    const activeTab = ref('');
    activeTab.value = prop.initActiveTab || '';

    const getTabName = (item) => item.name;

    const isActiveTab = (key) => key === activeTab.value;

    /** 自动滚动tab，将当前tab展示在可视范围内 */
    const autoScrollTab = () => {
      nextTick(() => {
        const containerEl = tabContainer.value;
        const containerW = containerEl?.offsetWidth || 0;
        const activeTabEl = document.querySelector(`#${prop.tabId} .tab-item.active`) as HTMLElement;
        // 获取到当前点击元素的 offsetLeft  - 包裹盒子 offsetWidth 的一半 + 当前点击元素 offsetWidth 的一半
        const scrollLeftNum = activeTabEl.offsetLeft - containerW / 2 + activeTabEl.offsetWidth / 2;

        // 赋值
        if (containerEl) {
          containerEl.scrollLeft = scrollLeftNum;
        }
      });
    };

    watchEffect(() => {
      if (prop.curActiveTab) {
        activeTab.value = prop.curActiveTab;
        autoScrollTab();
      }
    });

    // 判断是否滚动
    const isTabScrollBi = ref(false);
    // 处理横向滚动距离
    onMounted(async () => {
      const container = document.getElementById(prop.tabId);

      container?.addEventListener('scroll', () => {
        // console.log('滑动了 tab', container.scrollLeft);
        if (!isTabScrollBi.value) {
          if (container.scrollLeft > 50) {
            biBrow('rewards.rewardstyp_scroll');
            isTabScrollBi.value = true;
          }
        }
      }, true);
    });

    const onClickTab = (e, key: string) => {
      if (key !== activeTab.value) {
        // 如果为非受控tab,则主动变更激活值
        if (!prop.curActiveTab) {
          activeTab.value = key;
        }
        // 触发tab变更
        emit('onClickTab', key);
        autoScrollTab();
      }
    };
    /** 是否为图片tab */
    const isImgTab = (tab: TabType) => tab.name.startsWith('https://');

    return {
      tabContainer,
      activeTab,
      getTabName,
      isActiveTab,
      onClickTab,
      isImgTab,
      isTabScrollEnd,
      parseCurrencyAria,
    };
  },
});
